<template>
  <v-chip v-if="props.value" :color="color" :outlined="isOutlined">{{ props.value }}</v-chip>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  value?: string
}>()

const color = computed(() => {
  switch (props.value) {
    case 'Queued':
      return 'blue lighten-4'
    case 'Success':
      return 'green lighten-4'
    case 'Partial Success':
      return 'orange lighten-4'
    case 'Failed':
      return 'red lighten-4'
    default:
      return null
  }
})

const isOutlined = computed(() => props.value === 'Queued')
</script>
